import { render, staticRenderFns } from "./newStores.vue?vue&type=template&id=95308204&"
import script from "./newStores.vue?vue&type=script&lang=js&"
export * from "./newStores.vue?vue&type=script&lang=js&"
import style0 from "./newStores.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports